import React from 'react';
import { Button } from 'react-bootstrap';
import { FiRotateCcw, FiSearch } from 'react-icons/fi';

import { titleCase } from '../../utils/format';

/**
 * Filter bar above the table. Fully controlled — the parent owns the query
 * object and this only reports changes, so the URL/state stays a single source
 * of truth for what the table is showing.
 */
export default function AppointmentFilters({
  query,
  options,
  onChange,
  onReset,
  resultCount,
  loading,
}) {
  const set = (patch) => onChange(patch);

  const hasFilters =
    query.q ||
    (query.status && query.status !== 'all') ||
    (query.modality && query.modality !== 'all') ||
    query.therapistId ||
    query.from ||
    query.to;

  return (
    <div className="mm-filters">
      <div className="mm-filters__row">
        <div className="mm-filters__search">
          <FiSearch size={16} aria-hidden="true" />
          <label className="mm-sr-only" htmlFor="admin-search">
            Search appointments
          </label>
          <input
            id="admin-search"
            type="search"
            placeholder="Search client, therapist or reference…"
            value={query.q}
            onChange={(e) => set({ q: e.target.value })}
          />
        </div>

        <div className="mm-filters__field">
          <label htmlFor="filter-status">Status</label>
          <select
            id="filter-status"
            value={query.status}
            onChange={(e) => set({ status: e.target.value })}
          >
            <option value="all">All statuses</option>
            {(options.statuses || []).map((s) => (
              <option key={s} value={s}>
                {titleCase(s)}
              </option>
            ))}
          </select>
        </div>

        <div className="mm-filters__field">
          <label htmlFor="filter-therapist">Therapist</label>
          <select
            id="filter-therapist"
            value={query.therapistId}
            onChange={(e) => set({ therapistId: e.target.value })}
          >
            <option value="">All therapists</option>
            {(options.therapists || []).map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </select>
        </div>

        <div className="mm-filters__field">
          <label htmlFor="filter-modality">Format</label>
          <select
            id="filter-modality"
            value={query.modality}
            onChange={(e) => set({ modality: e.target.value })}
          >
            <option value="all">All formats</option>
            {(options.modalities || []).map((m) => (
              <option key={m} value={m}>
                {titleCase(m)}
              </option>
            ))}
          </select>
        </div>

        <div className="mm-filters__field">
          <label htmlFor="filter-from">From</label>
          <input
            id="filter-from"
            type="date"
            value={query.from}
            onChange={(e) => set({ from: e.target.value })}
          />
        </div>

        <div className="mm-filters__field">
          <label htmlFor="filter-to">To</label>
          <input
            id="filter-to"
            type="date"
            value={query.to}
            onChange={(e) => set({ to: e.target.value })}
          />
        </div>
      </div>

      <div className="mm-filters__meta">
        <span aria-live="polite">
          {loading
            ? 'Loading…'
            : `${resultCount} appointment${resultCount === 1 ? '' : 's'}`}
        </span>
        {hasFilters && (
          <Button variant="link" className="mm-filters__reset" onClick={onReset}>
            <FiRotateCcw size={13} aria-hidden="true" />
            Clear filters
          </Button>
        )}
      </div>
    </div>
  );
}
